/**
 * Created by wuyanbin on 2019/7/15
 */
import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Button, Input, Form } from 'antd';
import { CHECK_MONEY } from '@/shared/reqexp';
import { formatNumOrSpace } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    priceGradient: rootState.priceGradient,
});
class PriceGradient extends Component {
    constructor() {
        super(...arguments);
        // 格式化数据源
        // [{ min: 0, max: 1, value: 100, type: 'isMin' }]
        this.formatSourceData = (sourceData) => {
            const tempSourceArr = [];
            sourceData.map((item, index) => {
                let tempType = '';
                if (item.type) {
                    tempType = item.type;
                }
                else {
                    tempType = formatNumOrSpace(item.max) === -1 ? 'isMax' : formatNumOrSpace(item.min) === 0 ? 'isMin' : 'range';
                }
                const tempObj = {
                    max: formatNumOrSpace(item.max),
                    min: formatNumOrSpace(item.min),
                    value: formatNumOrSpace(item.value),
                    type: tempType,
                    tipKeyWord: `tip-${tempType}-${index}-${new Date().getTime()}`,
                    reserveKeyWord: `reserve-${tempType}-${index}-${new Date().getTime()}`,
                };
                tempSourceArr.push(tempObj);
            });
            return tempSourceArr;
        };
        /**
         * 增加
         * 插入到倒数第二个位置
         * { min: 1, max: 3, value: 200, type: 'range' }
         * 最小值取上一个位置的（当前数组中倒数第二个的最大值）
         * 最大值取下一个位置的（当前数组中最后一个的最小值）
         * @param item
         * @param index
         */
        this.addItem = (item, index) => {
            // const { priceGradientSteps } = this.props.priceGradient;
            // const tempItemMin = priceGradient[priceGradient.length - 2].max;
            // const tempItemMax = priceGradientSteps[priceGradientSteps.length - 1].min;
            const tempItem = {
                min: '',
                max: '',
                value: '',
                type: 'range',
                tipKeyWord: `tip-range-${new Date().getTime()}`,
                reserveKeyWord: `reserve-range-${new Date().getTime()}`,
            };
            dispatch.priceGradient.addItem(tempItem);
        };
        /**
         * 删除
         */
        this.deleteItem = (item, index) => {
            dispatch.priceGradient.deleteItem({ index });
        };
        /**
         * 修改价格区间值
         * @param item
         * @param index
         * @param e
         */
        this.handleInputChange = (item, index, e) => {
            const payload = { item, index, value: formatNumOrSpace(e.target.value) };
            dispatch.priceGradient.handleInputChange(payload);
        };
        /**
         * 修改收费金额
         * @param item
         * @param index
         * @param e
         */
        this.handleTipMoneyInputChange = (item, index, e) => {
            const payload = { item, index, value: formatNumOrSpace(e.target.value) };
            dispatch.priceGradient.handleTipMoneyInputChange(payload);
        };
    }
    componentWillReceiveProps(nextProps) {
        // console.log('componentWillReceiveProps传递进来的值', nextProps);
        // console.log('对比', this.props.fixSteps !== nextProps.fixSteps);
        if (this.props.fixSteps !== nextProps.fixSteps || this.props.isCanEditAble !== nextProps.isCanEditAble) {
            // console.log('我执行了');
            dispatch.priceGradient.SET_STATE({
                priceGradientSteps: this.formatSourceData(nextProps.fixSteps) || [],
            });
        }
    }
    componentDidMount() {
        // console.log('componentDidMount传递进来的值', this.props.fixSteps);
        dispatch.priceGradient.SET_STATE({
            priceGradientSteps: this.formatSourceData(this.props.fixSteps) || [],
        });
    }
    /**
     * 渲染价格区间
     * 0  - x1 val: item.max
     * x1 - x2 val: item.min - item.max
     * x2 - ∞  val: item.min
     */
    _renderPriceRange(item, index) {
        const { isCanEditAble } = this.props;
        const { getFieldDecorator } = this.props.form;
        if (item.type === 'isMin') {
            return (<Form.Item>
          {getFieldDecorator(item.reserveKeyWord, {
                rules: [{ validator: CHECK_MONEY(true, '', 999) }],
                initialValue: item.max,
            })(<Input addonAfter="万元以下" style={{ width: '280px' }} disabled={!isCanEditAble} onChange={(e) => {
                this.handleInputChange(item, index, e);
            }}/>)}
        </Form.Item>);
        }
        else if (item.type === 'range') {
            return (<React.Fragment>
          <Form.Item>
            <Input addonAfter="万元(含)" disabled={true} value={item.min}/>
          </Form.Item>
          <div>-</div>
          <Form.Item>
            {getFieldDecorator(item.reserveKeyWord, {
                rules: [{ validator: CHECK_MONEY(true, '', 999) }],
                initialValue: item.max,
            })(<Input addonAfter="万元" disabled={!isCanEditAble} onChange={(e) => {
                this.handleInputChange(item, index, e);
            }}/>)}
          </Form.Item>
        </React.Fragment>);
        }
        else {
            return (<Form.Item>
          <Input style={{ width: '280px' }} addonAfter="万元以上" disabled={true} value={item.min} onChange={(e) => {
                this.handleInputChange(item, index, e);
            }}/>
        </Form.Item>);
        }
    }
    // 渲染操作按钮
    _renderBtn(item, index) {
        const { isCanEditAble, maxLenStep } = this.props;
        const { priceGradientSteps } = this.props.priceGradient;
        if (item.type === 'isMin' && priceGradientSteps.length < maxLenStep) {
            return (<Button disabled={!isCanEditAble} type="link" onClick={() => {
                this.addItem(item, index);
            }}>
          添加
        </Button>);
        }
        else if (item.type === 'range') {
            return (<Button className={'self-btn-color'} disabled={!isCanEditAble} type="link" onClick={() => {
                this.deleteItem(item, index);
            }}>
          删除
        </Button>);
        }
        else {
            return null;
        }
    }
    render() {
        const { priceGradientSteps } = this.props.priceGradient;
        const { isCanEditAble } = this.props;
        const { getFieldDecorator } = this.props.form;
        // console.log('priceGradient', priceGradientSteps);
        return (<div>
        {priceGradientSteps && priceGradientSteps.length > 0 && priceGradientSteps.map((item, index) => {
            return (<div key={index} style={{ display: 'flex', marginTop: '10px' }}>
                <div style={{ display: 'flex', width: '280px' }}>
                  
                  {this._renderPriceRange(item, index)}
                </div>
                <div>
                  
                  <Form.Item>
                    {getFieldDecorator(item.tipKeyWord, {
                rules: [{ validator: CHECK_MONEY(true, 'hundred', 999999, true) }],
                initialValue: formatNumOrSpace(item.value),
            })(<Input disabled={!isCanEditAble} style={{ marginLeft: '10px', width: '120px' }} addonAfter="元" onChange={(e) => {
                this.handleTipMoneyInputChange(item, index, e);
            }}/>)}
                  </Form.Item>
                </div>
                
                <div>
                  {isCanEditAble && this._renderBtn(item, index)}
                </div>
              </div>);
        })}
      </div>);
    }
}
PriceGradient.defaultProps = {
    fixSteps: [
        { min: 0, max: '', value: '', type: 'isMin' },
        { min: '', max: -1, value: '', type: 'isMax' },
    ],
    isCanEditAble: true,
    maxLenStep: 2,
};
export default connect(mapStateToProps)(PriceGradient);
